/**
 * Utilitaire de formatage des dates avec fuseau horaire
 * Utilise le fuseau stocké dans les paramètres utilisateur (localStorage)
 */

// Mapping des labels fuseau → identifiants IANA
const TIMEZONE_MAP = {
  'Europe/Paris (GMT+1)': 'Europe/Paris',
  'Africa/Tunis (GMT+1)': 'Africa/Tunis',
  'America/New_York (GMT-5)': 'America/New_York',
  'Asia/Dubai (GMT+4)': 'Asia/Dubai',
};

function getTimezone() {
  try {
    const stored = localStorage.getItem('fuseau');
    if (stored && TIMEZONE_MAP[stored]) return TIMEZONE_MAP[stored];
    if (stored && !stored.includes('(')) return stored; // déjà un identifiant IANA
  } catch {}
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
}

/**
 * Formater une date complète (jour + heure)
 * Ex: "01/04/2026 14:30:05"
 */
export function formatDateTime(dateStr) {
  if (!dateStr) return '—';
  const d = new Date(dateStr);
  if (isNaN(d.getTime())) return '—';
  return d.toLocaleString('fr-FR', {
    timeZone: getTimezone(),
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  });
}

/**
 * Formater une date courte (jour uniquement)
 * Ex: "01/04/2026"
 */
export function formatDate(dateStr) {
  if (!dateStr) return '—';
  const d = new Date(dateStr);
  if (isNaN(d.getTime())) return '—';
  return d.toLocaleDateString('fr-FR', {
    timeZone: getTimezone(),
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  });
}

/**
 * Formater une date lisible (jour mois année)
 * Ex: "1 avril 2026"
 */
export function formatDateLong(dateStr) {
  if (!dateStr) return '—';
  const d = new Date(dateStr);
  if (isNaN(d.getTime())) return '—';
  return d.toLocaleDateString('fr-FR', {
    timeZone: getTimezone(),
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  });
}

/**
 * Formater mois + année
 * Ex: "avr. 2026"
 */
export function formatDateShort(dateStr) {
  if (!dateStr) return '—';
  const d = new Date(dateStr);
  if (isNaN(d.getTime())) return '—';
  return d.toLocaleDateString('fr-FR', {
    timeZone: getTimezone(),
    month: 'short',
    year: 'numeric',
  });
}

/**
 * Formater jour + mois court + année
 * Ex: "1 avr. 2026"
 */
export function formatDateMedium(dateStr) {
  if (!dateStr) return '—';
  const d = new Date(dateStr);
  if (isNaN(d.getTime())) return '—';
  return d.toLocaleDateString('fr-FR', {
    timeZone: getTimezone(),
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  });
}

/**
 * Sauvegarder le fuseau dans localStorage
 */
export function saveTimezone(fuseauLabel) {
  try {
    localStorage.setItem('fuseau', fuseauLabel);
  } catch {}
}
